import React from "react";
import { Link, withRouter } from "react-router-dom";
import { FaPlus, FaMinus, FaTrashAlt } from "react-icons/fa";
import { Config } from "../../Config";

const CartItem = (props) => {
  // const productShowHandler = (id) => {
  //   props.history.replace({
  //     // pathname: `/products/${id}`,
  //     pathname: `/products/${id}`,
  //     state: { productId: id },
  //   });
  // };
  return (
    <React.Fragment>
      {props.cartData.map((item, index) => {
        return (
          <div key={index} className="cartItems">
            <div className="cartItemImage">
              <Link to={`/products/${item.id}/${item.productName.replaceAll(" ", "-")}`}>
                <img src={item.productImage} alt={item.productName} />
              </Link>
            </div>
            <div className="cartItemInfo">
              <Link to={`/products/${item.id}/${item.productName.replaceAll(" ", "-")}`} className="title">
                {item.productName}
                <div className="approve">{item.isApproved ? "دولتی" : "آزاد"}</div>
              </Link>
              <p className="amount">
                <span className="showMobile">قیمت(ریال)</span> {Config.separate(item.unitPrice)}
              </p>
              <div className="amountCount">
                <FaPlus className="fa-plus" onClick={() => props.cartCountPlus(item)} />
                <input
                  className="amountCountInput"
                  disabled
                  value={item.count}
                  min="1"
                  max={item.count}
                  type="number"
                  name=""
                />
                <FaMinus className="fa-minus" onClick={() => props.cartCountMinus(item)} />
              </div>
              <p className="totalAmount">
                <span className="showMobile">مجموع(ریال)</span> {Config.separate(item.unitPrice * item.count)}
              </p>
              <button className="deleteItem" onClick={() => props.deleteCartItemHandler(item)}>
                <FaTrashAlt /> حذف
              </button>
            </div>
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default React.memo(withRouter(CartItem));
